export const PATH_CONNECTIONS = () => '/wb/connections';
export const PATH_NOTEBOOK = () => '/wb/notebook';
export const PATH_CATEGORIES_BROWSE = () => '/wb/categories/browse';
export const PATH_CATEGORIES_ADD = () => '/wb/categories/add';
export const PATH_CATEGORIES_EDIT = id => `/wb/categories/${id}/edit`;
export const PATH_CATEGORIES_VIEW = id => `/wb/categories/${id}/view`;

export default {
  '/connections': {
    title: 'Connections',
  },
  '/tab': {
    '/:id': {},
  },
  '/window': {
    '/connections': {
      icon: 'database',
    },
    '/home': {
      icon: 'home',
    },
    '/query/:id': {
      title: 'Untitled',
      icon: 'code-o',
    },
    '/browse': {
      icon: 'folder',
    },
    '/new_category': {
      title: '*New Category',
      icon: 'inbox',
    },
    '/category/:id': {
      title: 'Category',
      icon: 'inbox',
    },
  },
};

/*
  '/wb': {
    '/notebook': {
      title: 'Notebook',
    },
    '/categories': {
      title: 'Categories',
      '/browse': {
        title: 'Browsing Categories',
      },
      '/add': {
        title: 'New Category',
      },
      '/:id': {
        title: 'Category:',
        '/edit': {
          title: 'Edit Category:',
        },
        '/view': {
          title: 'View Category:',
        },
      },
    },
  },
 */
